"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateVenueLocationRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class UpdateVenueLocationRequestDto {}
exports.UpdateVenueLocationRequestDto = UpdateVenueLocationRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'WGS84 latitude'
}), __metadata("design:type", Number)], UpdateVenueLocationRequestDto.prototype, "latitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'WGS84 longitude'
}), __metadata("design:type", Number)], UpdateVenueLocationRequestDto.prototype, "longitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UpdateVenueLocationRequestDto.prototype, "address", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], UpdateVenueLocationRequestDto.prototype, "postalCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Optional viewport NE latitude; computed from point when omitted.'
}), __metadata("design:type", Number)], UpdateVenueLocationRequestDto.prototype, "northeastLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Optional viewport NE longitude; computed from point when omitted.'
}), __metadata("design:type", Number)], UpdateVenueLocationRequestDto.prototype, "northeastLongitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Optional viewport SW latitude; computed from point when omitted.'
}), __metadata("design:type", Number)], UpdateVenueLocationRequestDto.prototype, "southwestLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Optional viewport SW longitude; computed from point when omitted.'
}), __metadata("design:type", Number)], UpdateVenueLocationRequestDto.prototype, "southwestLongitude", void 0);
//# sourceMappingURL=UpdateVenueLocationRequest.dto.js.map